import { GET_BOAT_TYPES_LOADING, GET_BOAT_TYPES_SUCCESS } from '../actionTypes';
import store from '../store';
import { showUnknownError } from './keyboard-shortcuts.actions';
import { client } from '../../services/client';

export const getBoatTypesSuccess = payload => {
    return ({
        type: GET_BOAT_TYPES_SUCCESS,
        payload
    })
}

export const getBoatTypesAsync = payload => dispatch => {
    return client.service('boat-types').find()
		.then((response) => {
            dispatch(getBoatTypesSuccess(response));
            return response
		})
        .catch((error) => {
            console.error('error', error);
        })
           
}